import {FormControl, Validators} from "@angular/forms";

export class Additionals {
    id: string;
    from_date: string;
    to_date: string;
    purchases_imports_reverse_calculation: string;
​    purchases_imports_reverse_calculation_return: string;
    ​purchases_imports_reverse_calculation_tax: string;
    ​purchases_imports_with_additional: string;
    ​purchases_imports_with_additional_return: string;
    ​purchases_imports_with_additional_tax: string;
    ​purchases_taxfree: string;
    ​purchases_taxfree_return: string;
    ​purchases_with_additional: string;​
    purchases_with_additional_return: string;
    ​purchases_with_additional_tax: string;
    ​purchases_with_zero: string;
    ​purchases_with_zero_return: string;
    ​sales_citizens: string;
    ​sales_citizens_return: string;
    ​sales_exports: string;
    ​sales_exports_return: string;
    ​sales_local_zero: string;
    ​sales_local_zero_return: string;
    ​sales_taxfree: string;
    ​sales_taxfree_return: string;
    ​sales_with_additional: string;
    ​sales_with_additional_return: string;
    ​sales_with_additional_tax: string;
    total_sales: string;
    total_sales_return: string;
    total_sales_tax: string;
    total_purchases: string;
    total_purchases_return: string;
    total_purchases_tax: string;
    total_tax: string;
    old_peroid_fixes: string;
    old_peroid_tax: string;
    final_tax: string;

  organization_id:string;
    last_on_behalf_of:string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/additionals/additionals.ts